export type NonEmptyArray<T> = [T, ...T[]];

export function isNonEmptyArray<T>(v: T[]): v is NonEmptyArray<T> {
  return v.length > 0;
}
